import {
  SnapshotDownloadDocument,
  SnapshotsPaginatedDocument,
} from "api/generated";
import { RequestTypes } from "api/services/enums";
import { getRequestInstance } from "api/services/utils";
import { Optional } from "config";

import { ISnapshotsListVars, ISnapshotListReturnType } from "./types";

export async function getSnapshotsList(
  variables: ISnapshotsListVars
): Promise<ISnapshotListReturnType> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: SnapshotsPaginatedDocument,
      variables,
      fetchPolicy: "cache-first",
    });

    return res?.data?.snapshotsPaginated;
  } catch (error) {
    throw error;
  }
}

export async function downloadSnapshotDocument(
  snapshotId: number
): Promise<Optional<string>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: SnapshotDownloadDocument,
      variables: {
        snapshotId,
      },
      fetchPolicy: "no-cache",
    });

    return res?.data?.snapshotDownload;
  } catch (error) {
    throw error;
  }
}
